import { ApiUtil } from '@/shared/api';

export const publishedBoxApi = {
    /** 발행함 - 발행하기 */
    postIntegPubExam: (param: API.IntegPubExam.Req) => {
        return ApiUtil.post<API.IntegPubExam.Res>('/integ/pub/exam', param);
    },

    /** 발행함 - 삭제 */
    postIntegPubDelete: (param: API.IntegPubDelete.Req) => {
        return ApiUtil.post<API.IntegPubDelete.Res>('/integ/publish/delete', param);
    },

    /** 발행함 - 닉네임 발행 인증 */
    postIntegPubNicknameAuth: (param: API.IntegPubNickNameAuth.Req) => {
        return ApiUtil.post<API.IntegPubNickNameAuth.Res>('/integ/publish/nickname-auth', param);
    },

    /** 발행함 - 닉네임 발행 인증 - 비밀번호 변경 */
    postIntergPubNewPw: (param: API.IntergPubNewPw.Req) => {
        return ApiUtil.post<API.IntergPubNewPw.Res>('/integ/publish/nickname-auth/new-pwd', param);
    },

    /** 발행 상세 조회 - 제한 시간 수정 */
    postIntegEditTimTime: (param: API.IntegPubEditTimTime.Req) => {
        return ApiUtil.post<API.IntegPubEditTimTime.Res>('/integ/publish/timTime', param);
    },

    /** 발행 상세 조회 - 응시 기간 수정 */
    postIntegEditPeriod: (param: API.IntegPubEditPeriod.Req) => {
        return ApiUtil.post<API.IntegPubEditPeriod.Res>('/integ/publish/pdSet', param);
    },

    /** 발행 상세 조회 - 학생 추가 */
    postIntegAddStnt: (param: API.IntegAddStnt.Req) => {
        return ApiUtil.post<API.IntegAddStnt.Res>('/integ/publish/addStdt', param);
    },

    /** 발행함 - 그룹별 발행 리스트 조회 */
    getIntegPubCompleteList: (param: API.IntegPubCompleteList.Req) => {
        return ApiUtil.get<API.IntegPubCompleteList.Res>('/integ/publish/grp/list', param);
    },

    /** 발행함 - 발행 리스트별 조회 */
    getPublishBoxList: (param: API.IntegPubList.Req) => {
        return ApiUtil.get<API.IntegPubList.Res>('/integ/publish/list', param);
    },

    /** 발행함 - 발행 닉네임별 조회 */
    getPublishNickList: (param: API.IntegPubNickList.Req) => {
        return ApiUtil.get<API.IntegPubNickList.Res>('/integ/publish/nickname-list', param);
    },

    /** 발행함 - 발행 학생별 조회 */
    getPublishStntList: (param: API.IntegPubStntList.Req) => {
        return ApiUtil.get<API.IntegPubStntList.Res>('/integ/publish/claStdt-list', param);
    },

    /** 발행함 - 발행 상세 조회 */
    getPublishDetail: (param: API.IntegPubDetail.Req) => {
        return ApiUtil.get<API.IntegPubDetail.Res>('/integ/publish/detail', param);
    },

    /** 발행함 - 발행 학생별 상세 조회 */
    getPublishStntDetail: (param: API.IntegPubStntDetail.Req) => {
        return ApiUtil.get<API.IntegPubStntDetail.Res>('/integ/publish/claStdt-detail', param);
    },

    /** 발행함 - 발행 상세 조회 - 학생 제출 정보 */
    getPublishSubStnt: (param: API.IntegPubStntSub.Req) => {
        return ApiUtil.get<API.IntegPubStntSub.Res>('/integ/publish/stdt-detail', param);
    },

    /** 발행함 - 발행 옵션 설정 - 최근 발행물 조회 */
    getRecentPublishedList: (param: API.RecentPublishedListType.Req) => {
        return ApiUtil.get<API.RecentPublishedListType.Res>('/integ/publish/recent-option', param);
    },

    /** 발행함 - 클래스 ID 목록 조회 */
    getClaIdList: (param: API.IntegClaIdListType.Req) => {
        return ApiUtil.get<API.IntegClaIdListType.Res>('/integ/common/cla/list', param);
    },

    /** 발행함 - 클래스 ID 검증 */
    getClaIdVerification: (param: API.IntegPubClaIdVerification.Req) => {
        return ApiUtil.get<API.IntegPubClaIdVerification.Res>('/integ/common/cla/info', param);
    },

    /** 발행함 - 학생별 학급 목록 조회 */
    getPubStntClassList: (param: API.IntegPubStntClassList.Req) => {
        return ApiUtil.get<API.IntegPubStntClassList.Res>('/integ/publish/claStdt-cla-list', param);
    },

    /** 발행함 - 학생별 상세 리스트 조회 */
    getPubStntDetailList: (param: API.IntegPubSntDetailList.Req) => {
        return ApiUtil.get<API.IntegPubSntDetailList.Res>('/integ/publish/claStdt-detail', param);
    },

    /** 발행함 - 학생 ID 조회 By 닉네임 */
    getStdtByNickName: (param: API.IntergPubStdtByNickName.Req) => {
        return ApiUtil.get<API.IntergPubStdtByNickName.Res>(
            '/integ/publish/stdt-by-nickname',
            param
        );
    },

    /** 발행함 - 발행 상세 힌트 노출 여부 수정 */
    postPubUpdateHint: (param: API.IntegPubUpdateHint.Req) => {
        return ApiUtil._post<API.IntegPubUpdateHint.Res>('/integ/publish/update-hint', param);
    },

    /** 발행함 - 발행 상세 - 학생 추가 */
    postIntegPubAddStdt: (param: API.IntegPubAddStdt.Req) => {
        return ApiUtil._post<API.IntegPubAddStdt.Res>(`/integ/publish/addStdt`, {
            stdtUserIds: param.stdtUserIds,
            publishId: param.publishId,
        });
    },

    /** 발행함 - 닉네임 발행 인증 - 비밀번호 초기화 */
    postIntegPubResetPwd: (param: API.IntergPubResetPwd.Req) => {
        return ApiUtil._post<API.IntergPubResetPwd.Res>(`/integ/publish/nickname-auth/init`, param);
    },
};
